import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from 'react-custom-scrollbars';
import onClickOutside from 'react-onclickoutside';

import Notification from './Notification';

import styles from './NotificationList.scss';

class NotificationsList extends Component {
    static propTypes = {
        isVisible: PropTypes.bool,
        onRead: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        list: PropTypes.array,
        listProcessing: PropTypes.bool
    };


    render() {
        const {isVisible} = this.props;
        if (!isVisible)
            return null;

        const {list, role} = this.props;

        return (
            <div className={styles.container}>
                <div className={styles.arrowUp} />
                <Scrollbars autoHeight autoHeightMax='25rem'>
                    {list.map(n => {
                        const {notificationId} = n;
                        return <Notification
                            role={role}
                            key={notificationId}
                            notification={n}
                            onRead={this.handleRead.bind(this, notificationId)} />
                    })}
                </Scrollbars>
            </div>
        );
    }

    handleRead(notificationId) {
        const {list, onRead} = this.props;

        if (notificationId)
            return onRead([notificationId]);
        onRead(list.map(n => {
            return n.notificationId;
        }));
    }

    handleClickOutside = (e) => {
        this.handleRead();
        const {onClose} = this.props;
        onClose();
    }
}

export default onClickOutside(NotificationsList);



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsList.js